import type { CSSProperties } from 'react';
import { UhcMedium, UhcMediumHeader } from '@src/apps/styles/common-style';

export const commonAppHeaderStyles: { [key: string]: CSSProperties } = {
  root: {
    position: 'relative',
    width: '100%'
  },
  headerMobile: {
    minWidth: '0',
    padding: '0 16px',
    columnGap: '8px'
  },
  header: {
    width: '100%',
    minWidth: '960px',
    maxWidth: '1610px',
    height: '72px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e0e0e0',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px 0 24px',
    fontFamily: UhcMedium,
    position: 'relative',
    zIndex: 999
  },
  menuWrap: {
    padding: '0 8px 0 0',
    display: 'inline-flex',
    alignItems: 'center'
  },
  menuButton: {
    borderRadius: '2px',
    padding: '6px',
    height: '36px',
    width: '36px',
    margin: 0,
    color: '#0b5cab',
    backgroundColor: 'transparent',
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  menuButtonHover: {
    backgroundColor: '#e6f3ff'
  },
  menuButtonActive: {
    backgroundColor: '#c6ddf5'
  },
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  logo: {
    width: '138px',
    height: '44px'
  },
  advancedContainer: {
    display: 'grid',
    gridTemplateColumns: '35% 50% 15%',
    alignItems: 'center',
    height: '100%',
    flex: 1,
    minWidth: 0
  },
  advancedActions: {
    gridColumn: 2,
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 440px) auto',
    columnGap: '15px',
    alignItems: 'center',
    justifyContent: 'start',
    width: 'fit-content',
    maxWidth: '100%',
    minWidth: 0
  },
  right: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  helpWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '14px'
  },
  aiBlock: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  helpIcon: {
    display: 'inline-flex'
  },
  aiTooltip: {
    position: 'absolute',
    left: '50%',
    top: 'calc(100% + 8px)',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    color: '#000000',
    border: '1px solid #c8cfd6',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.12)',
    padding: '15px',
    borderRadius: '4px',
    fontFamily: UhcMedium,
    fontSize: '12px',
    lineHeight: '16px',
    minWidth: '180px',
    maxWidth: 'none',
    whiteSpace: 'normal',
    zIndex: 10000,
    pointerEvents: 'none'
  },
  aiTooltipContent: {
    display: 'block'
  },
  aiTooltipVisible: {
    opacity: 1,
    visibility: 'visible'
  },
  aiTooltipHidden: {
    opacity: 0,
    visibility: 'hidden'
  },
  aiTooltipArrow: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderBottom: '5px solid #ffffff',
    filter: 'drop-shadow(0 -1px 0 #c8cfd6)'
  },
  kcBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer'
  },
  kcText: {
    color: '#757588',
    fontFamily: UhcMediumHeader,
    fontSize: '16px',
    letterSpacing: '0.2px',
    lineHeight: '22px'
  }
};
